// extracted by mini-css-extract-plugin
module.exports = {"SelectCard":"SelectCard_SelectCard__7efOO"};